// import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// function Protected(props) {
//   const { Component, requiredRole } = props;
//   const navigate = useNavigate();

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const role = localStorage.getItem("role");

//     if (!token) {
//       navigate("/");
//     } else if (requiredRole && role !== requiredRole) {
//       navigate("/dashboard");
//     }
//   }, [requiredRole, navigate]);

//   return <Component />;
// }

// export default Protected;

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Protected({ Component, requiredRole, isPublic = false }) {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    if (isPublic) {
      // Public route (Login, SignUp, etc.)
      if (token) {
        navigate("/dashboard/whatsappcloud"); // Already logged in → redirect to dashboard
      }
    } else {
      // Private route (Dashboard, Contacts, etc.)
      if (!token) {
        navigate("/"); // Not logged in → redirect to login
      } else if (requiredRole && role !== requiredRole) {
        navigate("/dashboard/whatsappcloud"); // Role restricted → redirect to dashboard
      }
    }
  }, [isPublic, requiredRole, navigate]);

  return <Component />;
}

export default Protected;
